/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentProviderTypes = sqliteTable('appointment_provider_types', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  provider_id: text('provider_id'),
  type: text('type'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
